<template>
  <ul
    ref="sidebar"
    class="navbar-nav bg-gradient-primary sidebar sidebar-dark"
    :class="{ toggled: toggledSidebar, fixed: fixedNavbar }">

    <RouterLink to="/" class="sidebar-brand d-flex align-items-center justify-content-center">
      <div v-if="$constant.APP === 'SINERGI'">
        <img src="/images/logo/rsud.png" style="width: 30px;">
        <div class="sidebar-brand-text mx-2">SINERGI</div>
      </div>

      <div v-if="$constant.APP === 'SIAPMAN'">
        <img src="/images/logo/siapman.png" style="width: 30px;">
        <div class="sidebar-brand-text mx-2">SIAPMAN 2.0</div>
      </div>
    </RouterLink>

    <hr class="sidebar-divider my-0">

    <li class="nav-item" v-for="(menus, moduleName) in userModules" :key="moduleName">
      <a v-b-toggle="`menu-${moduleName}`" class="nav-link"  data-toggle="collapse">
        <i v-if="menus.length" class="fas fa-fw" :class="`fa-${menus[0].Module.Icon}`" />
        <span class="text-uppercase font-weight-bold">{{ moduleName }}</span>
      </a>
      <b-collapse
        :id="`menu-${moduleName}`"
        accordion="menu"
        v-if="menus.length"
        :visible="menus.some(menu => $route.path === menu.Url)">
        <div class="bg-white py-2 collapse-inner rounded">
          <RouterLink
            :to="menu.Url"
            class="collapse-item"
            :event="!isLoading ? 'click' : ''"
            v-for="menu in menus" :key="menu.ID">

            {{ menu.Name }}
          </RouterLink>
        </div>
      </b-collapse>
    </li>


    <hr class="sidebar-divider d-none d-md-block">
    <div class="text-center d-none d-md-inline">
      <button id="sidebarToggle" class="rounded-circle border-0" @click="toggleSidebar" />
    </div>

  </ul>
</template>

<script>
import PerfectScrollbar from 'perfect-scrollbar'

export default {
  mounted () {
    const ps = new PerfectScrollbar(this.$refs.sidebar)

    this.loadUserModules()

  },
  data () {
    return {
      userModules: {}
    }
  },
  computed: {
    toggledSidebar () {
      return this.$store.state.collapsedSidebar
    },
    fixedNavbar () {
      return this.$store.state.fixedNavbar
    },
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    toggleSidebar () {
      this.$store.commit('toggleSidebar')
    },

    loadUserModules () {

      if (!this.$store.state.user.userData) {
        return
      }

      const roles = this.$store.state.user.userData.roles

      // is super admin?
      if (roles.some(role => role.ID === 1)) {
        this.$axios.get('menu?visible=1').then(({ data }) => {

          this.groupMenuByModule(data)
        })

      } else {
        for (let i = 0; i < roles.length; i++) {
          this.groupMenuByModule(roles[i].Menus)
        }
      }

    },

    groupMenuByModule (menus) {
      for (let j = 0; j < menus.length; j++) {

        const currentMenu = menus[j]
        const moduleName = currentMenu.Module.Name

        if (!this.userModules[moduleName]) {
          this.$set(this.userModules, moduleName, [])
        }

        this.userModules[moduleName].push(currentMenu)
      }
    }
  }
}
</script>
